module.exports = __webpack_public_path__ + "assets/4e939f65421eeadd2a32c3e269dd73f4.mp3";